import { render, staticRenderFns } from "./Paperwork.html?vue&type=template&id=d7ff3f78&scoped=true&lang=html&"
import script from "./Paperwork.js?vue&type=script&lang=js&"
export * from "./Paperwork.js?vue&type=script&lang=js&"
import style0 from "./Paperwork.css?vue&type=style&index=0&id=d7ff3f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ff3f78",
  null
  
)

export default component.exports